/**
 * LoadingIcon class can be used show or hide a loading icon.
 *
 * @example
 *
 * HTML
 * <div class="loading-icon-holder"></div>
 *
 * Javascript code - To show icon
 * LoadingIcon.instances['car-search-loading-icon'].show = true;
 */
export default class LoadingIcon {

  /**
   * @private
   * @property {HTMLElement} element all logic is bind the this element
   */
  #element;

  /**
   * Loader icon instances, use this to manipulate loader icons on the page.
   * @public
   * @property {LoadingIcon} instances loading icon instances
   */
  static instances = {};

  /**
   * @constructor
   * @param {HTMLElement} element element bind to
   * @throws {Error}
   */
  constructor(element) {
    this.#element = element;

    if(!this.#element.id) {
      throw new Error('LoadingIcon container should have an ID-attribute');
    }

    LoadingIcon.instances[ this.#element.id ] = this;
  }

  /**
   * Accessor for hiding or showing the loader icon
   * @param {boolean} enabled true to show loader pass false to hide it
   */
  set show(enabled) {
    this.#element.classList.toggle('show', enabled);
  }

  /**
   * Initializes all loading icon holders on the page
   */
  static init() {
    document.querySelectorAll('.loading-icon-holder').forEach( element => {
      new LoadingIcon(element);
    });
  }
}
